export default __webpack_public_path__ + "static/media/logoquestions.21e085ff.jpg";